


































import { Component, Ref } from 'vue-property-decorator';

import Edit from '@/layouts/Edit';
import EditBlock from '@/views/CRUD/Edit.vue';
import TitleReturn from '@/components/TitleReturn.vue';
import FormView, { formSubmitData } from './_form.vue';
import CPBtn from '@/components/buttons/CPBtn/CPBtn.vue';
import ConfirmModal from '@/components/modal/ConfirmModal.vue';

import SubscriptionsEntityModule from '@/store/subscriptions/entity';
import ResponseHandlerModule from '@/store/modules/responseHandler';
import { strings } from '@/lib/stringConst';

import { getListForMultiSelect } from '@/utils/entity';

@Component({
    components: {
        EditBlock,
        TitleReturn,
        FormView,
        CPBtn,
        ConfirmModal,
    },
})
export default class SubscriptionsEditPage extends Edit {
    @Ref() $form!: FormView;

    titleEdit = '';
    formValues: any = {};
    subscriptionText = {
        subActivate: 'Активировать автопродление подписки',
        subCancel: 'Отменить автопродление подписки',
    }
    text = { ...strings, ...this.subscriptionText };

    confirmRemovalModal = false

    openModal() {
        this.confirmRemovalModal = true;
    }

    closeModal() {
        this.confirmRemovalModal = false;
    }

    get subscriptionId() {
        return this.$route.params.subscriptionsId;
    }

    returnToList() {
        this.$router.push({ name: 'subscriptions' });
    }

    async init() {
        try {
            const result = await SubscriptionsEntityModule.getById(this.subscriptionId);

            this.formValues = result;
            this.titleEdit = this.formValues?.subscriptionType?.title;
            this.initLists();
        } catch (error) {
            ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });

            ResponseHandlerModule.cancelRedirectToNotFound();
            this.returnToList();
        }
    }

    async initLists() {
        SubscriptionsEntityModule.SET_MULTI_SELECT_LIST_BY_TYPE({ type: 'specializations', list: await getListForMultiSelect('specializations') });
        SubscriptionsEntityModule.SET_MULTI_SELECT_LIST_BY_TYPE({ type: 'medicalServiceTypes', list: await getListForMultiSelect('medical-service-types') });
    }

    async updateIsAutoRenewal() {
        const result = await SubscriptionsEntityModule.getById(this.subscriptionId);
        this.formValues.isAutoRenewal = result.isAutoRenewal;
    }

    async activate() {
        const status = await SubscriptionsEntityModule.sendActivateSubscription(this.subscriptionId);
        if (status === 'ok') {
            this.updateIsAutoRenewal();
            ResponseHandlerModule.showNotify({ message: 'Автопродление подписки активировано', type: 'ok' });
        }
    }

    async cancel() {
        const status = await SubscriptionsEntityModule.sendCancelSubscription(this.subscriptionId);
        if (status === 'ok') {
            this.updateIsAutoRenewal();
            ResponseHandlerModule.showNotify({ message: 'Автопродление подписки отменено', type: 'ok    ' });
        }
    }

    async remove() {
        const status = await SubscriptionsEntityModule.sendRemoveSubscription(this.subscriptionId);
        if (status === 'ok') {
            this.returnToList();
        }
    }

    async save() {
        this.$form.update();
    }

    update(data: formSubmitData) {
        SubscriptionsEntityModule.update({ id: this.subscriptionId, data });
    }

    async mounted() {
        await this.init();
    }
}
